import React, { Component } from "react";
import { ChatModel, LoginResponse, SurveyQuestionsForUserModel } from "../../models";
import { wglcsApiService } from "../../services/WglcsApiService";
import { utils } from "../../utils";
// import Cookies from "universal-cookie";
import EventEmitter, { Events } from "../../services/eventemitter";
import _, { unset } from "lodash";
import { cookieService } from "../../services/CookieService";
import RouteSurveyQuestion from "./../../views/surveyQuestions/RouteSurveyQuestion";
// const cookies = new Cookies();

interface SurveyQuestionProps {
    chatSize: any
    OnBreak: any
}

interface SurveyQuestionState {
    surveyQuestions: SurveyQuestionsForUserModel[],
    isOpenSurvey: boolean
}

class SurveyQuestionTimer extends Component<SurveyQuestionProps, SurveyQuestionState> {
    surveyQuestionInterval!: NodeJS.Timeout;
    isOpenForcfully = false
    userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;

    constructor(props) {
        super(props);
        this.state = {
            surveyQuestions: [],
            isOpenSurvey: false
        }
        EventEmitter.on(Events.showPendingSurvey, this.showForcefully);
        EventEmitter.on(Events.startSurveyTimer, this.startSurveyTimer);
    }



    startSurveyTimer=()=>{
        var path = utils.getCurrentPathName()
        if (utils.isOperaterScreenActive()) {
            this.fireSurveyQuestionInterval();
        }
        else{
            clearInterval(this.surveyQuestionInterval); 
        }
    }

    componentWillUnmount() {
        clearInterval(this.surveyQuestionInterval);
    }


    sendSurveyBroadcast = () => {
        const unSentChatBroadCast = new BroadcastChannel("survey_count_notify")
        unSentChatBroadCast.postMessage("survey_count_notify")
    }

    showForcefully = () => {
        var questions = this.getPersistedSurveyQuestions()
        if (questions?.length > 0) {
            localStorage.setItem("surveyRouting", "True")
            this.isOpenForcfully = true
            this.setState({ surveyQuestions: questions });
            this.setState({ isOpenSurvey: true });
            this.sendSurveyBroadcast()
        }
    }
    fireSurveyQuestionInterval = async () => {
        let surveyTime = 60000;
        if (utils.isLiveAdminsCompany(this.userData.userLoginData.empCompId)) {
            let appLookUps = (await wglcsApiService.applookup_bycategory("Survey Route Time"))?.data!.data;
            if (appLookUps != null) {
                surveyTime = 60000 * parseInt(appLookUps[0].value);
            }
            let hasSurveyInterface = _.some(this.userData.interfaces, (iFace) => iFace.interfaceName.toLowerCase() == "Survey".toLowerCase());
            if (hasSurveyInterface) {
                clearInterval(this.surveyQuestionInterval);
                this.surveyQuestionInterval = setInterval(this.surveyQuestionIntervalMethod, surveyTime);
            }
        }
    };

    surveyQuestionIntervalMethod = async () => {

        var openedWindows = cookieService.getElectronCookies("RoutedSurveyCount")

        if (openedWindows == "NaN" || openedWindows == undefined || openedWindows < 0) {
            await cookieService.setElectronCookies("RoutedSurveyCount", 0)
        }

        if (this.state.isOpenSurvey) {
            return;
        }
        if (openedWindows >= 2) {
            return;
        }

        var surveyQuestions: any = await wglcsApiService.getSurveyQuestionsForUser(this.userData.userLoginData.userId);
        surveyQuestions = surveyQuestions?.data!.data


        var oneQuestion: any = []
        var persistedQs = this.getPersistedSurveyQuestions()
        if (persistedQs?.length > 0) {
            let qs = surveyQuestions?.filter((item) => item.questionId != persistedQs[0]?.questionId);
            if (qs?.length > 0) {
                oneQuestion = surveyQuestions?.filter((item) => item.questionId == qs[0]?.questionId);
            }
        }
        else {
            oneQuestion = surveyQuestions?.filter((item) => item.questionId === surveyQuestions[0]?.questionId);
        }


        if (oneQuestion?.length > 0) {
            if (window.innerWidth > 768) {
                localStorage.setItem("surveyRouting", "True")
                this.isOpenForcfully = false
                this.setState({ surveyQuestions: oneQuestion });
                this.setState({ isOpenSurvey: true });
            }
        }
    };

    // PersistSurveyQuestionToLocalStorage(surveyQuestions: SurveyQuestionsForUserModel[]) {
    //     localStorage.setItem("surveyQuestions", JSON.stringify(surveyQuestions));
    // }

    getPersistedSurveyQuestions(): SurveyQuestionsForUserModel[] {
        var res = JSON.parse(localStorage.getItem("surveyQuestions")!);
        if (res == null) {
            return []
        }
        return res
    }

    render(): React.ReactNode {
        if (this.state.isOpenSurvey) {
            return <RouteSurveyQuestion isOpenForcfully={this.isOpenForcfully} handleCloseSurvey={() => this.setState({ isOpenSurvey: false })} isOpenSurvey={this.state.isOpenSurvey} oneQuestion={this.state.surveyQuestions} />
        }
        return ""
    }
}

export default React.memo(SurveyQuestionTimer)
